import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DOCUMENTS_API_V2 } from "./apiRoutes";

interface UseGetPostedDocByIdProps {
  communityId: string;
  id: string;
  entryView?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPostedDocById = async (communityId: string, id: string, entryView: boolean = false) =>
  await axiosAuth.get(`${DOCUMENTS_API_V2(communityId)}/posted/${id}?entryView=${entryView}`);

const useGetPostedDocById = ({
  communityId,
  id,
  entryView,
  queryParams,
}: UseGetPostedDocByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["posted-doc-by-id", id],
    queryFn: () => getPostedDocById(communityId, id, entryView),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPostedDocById;
